import { render, staticRenderFns } from "./EmptyID.vue?vue&type=template&id=a170eb10&"
import script from "./EmptyID.vue?vue&type=script&lang=js&"
export * from "./EmptyID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports